import { Component } from '@angular/core';
import { MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-investment-return-dialog',
  templateUrl: './investment-return-dialog.component.html',
  styles: []
})
export class InvestmentReturnDialogComponent {

  revenueAmount: number = 0;

  constructor(public dialogRef: MatDialogRef<InvestmentReturnDialogComponent>) { }

  cancel(): void {
    this.dialogRef.close();
  }

}
